// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

import $ from 'jquery';
import Features from '../_modules/features/features.js';
import Footer from '../_modules/footer/footer.js';
import '../../node_modules/slick-carousel/slick/slick.min.js';

$(() => {

  $('a[href^="#"]').on('click', function(event) {
    var target = $(this.getAttribute('href'));
    if( target.length ) {
        event.preventDefault();
        $('html, body').stop().animate({
            scrollTop: target.offset().top
        }, 500);
    }
  });

  new Features();
  new Footer();

  // Define slider object
  var slickSlider = $(".slides");

  // Set tabindex -1 on initialize (we only use the arrows for tab-nav)
  slickSlider.on("init", function() {
    $(slickSlider).find('.slick-slide.slick-active').each(function() {
      $(this).attr('tabindex', '-1');
    });
  });

  // Initialize the slider
  slickSlider.slick({
    infinite: true,
    slidesToShow: 5,
    infinite: true,
    centerMode: true,
    centerPadding: '50px',
    accessibility: false,
    lazyLoad: 'progressive',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Volgende" type="button" tabindex="0">Volgende</button>',
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Vorige" type="button" tabindex="0">Vorige</button>',
    responsive: [{
      breakpoint: 1640,
      settings: {
        slidesToShow: 4
      }
    }, {
      breakpoint: 1140,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 800,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint:420,
      settings: {
        slidesToShow: 1
      }
    }]
  });


});
